import { render, staticRenderFns } from "./CurriculumSyllabusNEC.vue?vue&type=template&id=6b5eb880&scoped=true&"
import script from "./CurriculumSyllabusNEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusNEC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5eb880",
  null
  
)

export default component.exports